import { HStack, Link, LinkBox, LinkOverlay } from "@chakra-ui/react";
import * as React from "react";
import { NavLink as RouterLink, useMatch } from "react-router-dom";

interface NavItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  href?: string;
  to?: string;
  end?: boolean;
  external?: boolean;
  active?: boolean;
}

export default function NavItem({
  active,
  children,
  end,
  href,
  icon,
  to,
  external,
}: NavItemProps) {
  const exactMatch = useMatch(to || href);
  const nestedMatch = useMatch(`${to}/*`);
  const match = active ?? Boolean(exactMatch || (!end && nestedMatch));
  const label = (
    <HStack gap="2">
      {icon}
      {children}
    </HStack>
  );
  const link =
    href === undefined ? (
      <RouterLink {...{ end, to }}>{label}</RouterLink>
    ) : (
      <Link
        color="inherit"
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        _hover={{ textDecoration: "none" }}
      >
        {label}
      </Link>
    );

  return (
    <LinkBox
      alignItems="center"
      bgImage={match ? "navActive" : undefined}
      boxShadow={
        match ? ("inset 0 0 0 1px rgba(255,255,255,0.05)" as any) : undefined
      }
      borderRadius="l1"
      color={match ? "white" : "white/80"}
      display="flex"
      fontWeight={match ? "medium" : "normal"}
      height="9"
      paddingLeft="2"
      paddingRight="3"
      transition="all"
      _hover={{
        background: match ? undefined : "white/6",
        color: "white",
      }}
      css={{ "& svg": { width: "20px", height: "20px" } }}
    >
      <LinkOverlay asChild color="inherit" fontSize="sm">
        {link}
      </LinkOverlay>
    </LinkBox>
  );
}
